import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const MediaLayoutNone = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => {
  return (
    <SvgIcon data-temporary-fix height={height} width={width} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.7143 1.55078H2.28571C1.41784 1.55078 0.714286 2.28951 0.714286 3.20078V12.8008C0.714286 13.712 1.41784 14.4508 2.28572 14.4508H29.7143C30.5822 14.4508 31.2857 13.7121 31.2857 12.8008V3.20078C31.2857 2.28951 30.5822 1.55078 29.7143 1.55078ZM2.28571 0.800781C1.02335 0.800781 0 1.8753 0 3.20078V12.8008C0 14.1263 1.02335 15.2008 2.28572 15.2008H29.7143C30.9767 15.2008 32 14.1263 32 12.8008V3.20078C32 1.8753 30.9767 0.800781 29.7143 0.800781H2.28571Z"
        fill={getColor(color, isColorInherited)}
      />
      <path
        d="M2.28571 4.10078C2.28571 3.60372 2.66947 3.20078 3.14286 3.20078H28.8571C29.3305 3.20078 29.7143 3.60372 29.7143 4.10078C29.7143 4.59784 29.3305 5.00078 28.8571 5.00078H3.14286C2.66947 5.00078 2.28571 4.59784 2.28571 4.10078Z"
        fill={getColor(color, isColorInherited)}
      />
      <path
        d="M2.28571 7.70078C2.28571 7.20372 2.66947 6.80078 3.14286 6.80078H28.8571C29.3305 6.80078 29.7143 7.20372 29.7143 7.70078C29.7143 8.19784 29.3305 8.60078 28.8571 8.60078H3.14286C2.66947 8.60078 2.28571 8.19784 2.28571 7.70078Z"
        fill={getColor(color, isColorInherited)}
      />
      <path
        d="M3.14286 10.4008C2.66947 10.4008 2.28571 10.8037 2.28571 11.3008C2.28571 11.7978 2.66947 12.2008 3.14286 12.2008H7.14286C7.61624 12.2008 8 11.7978 8 11.3008C8 10.8037 7.61624 10.4008 7.14286 10.4008H3.14286Z"
        fill={getColor(color, isColorInherited)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.28571 0.800781C1.02335 0.800781 0 1.8753 0 3.20078V12.8008C0 14.1263 1.02335 15.2008 2.28572 15.2008H29.7143C30.9767 15.2008 32 14.1263 32 12.8008V3.20078C32 1.8753 30.9767 0.800781 29.7143 0.800781H2.28571ZM29.7143 1.55078H2.28571C1.41784 1.55078 0.714286 2.28951 0.714286 3.20078V12.8008C0.714286 13.712 1.41784 14.4508 2.28572 14.4508H29.7143C30.5822 14.4508 31.2857 13.7121 31.2857 12.8008V3.20078C31.2857 2.28951 30.5822 1.55078 29.7143 1.55078ZM3.14286 3.20078C2.66947 3.20078 2.28571 3.60372 2.28571 4.10078C2.28571 4.59784 2.66947 5.00078 3.14286 5.00078H28.8571C29.3305 5.00078 29.7143 4.59784 29.7143 4.10078C29.7143 3.60372 29.3305 3.20078 28.8571 3.20078H3.14286ZM3.14286 6.80078C2.66947 6.80078 2.28571 7.20372 2.28571 7.70078C2.28571 8.19784 2.66947 8.60078 3.14286 8.60078H28.8571C29.3305 8.60078 29.7143 8.19784 29.7143 7.70078C29.7143 7.20372 29.3305 6.80078 28.8571 6.80078H3.14286ZM2.28571 11.3008C2.28571 10.8037 2.66947 10.4008 3.14286 10.4008H7.14286C7.61624 10.4008 8 10.8037 8 11.3008C8 11.7978 7.61624 12.2008 7.14286 12.2008H3.14286C2.66947 12.2008 2.28571 11.7978 2.28571 11.3008Z"
        fill={getColor(color, isColorInherited)}
      />
    </SvgIcon>
  );
};
